// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"39100475","483":"ecfc65fb","589":"380417c6","787":"d7eb7b8f","928":"65dfc9da","990":"aa869d7e"}[chunkId] + ".chunk.js";
};